import { ReactNode } from 'react'
import { Button } from 'ui'
import { LoaderInCentalPosition } from 'widget'

import style from './ProductOrderFooter.module.scss'

type ProductOrderButton = {
  onClick: () => void
  Icon: ReactNode
  text: string
  disabled?: boolean
  isLoading?: boolean
}

type ProductOrderFooterProps = {
  nextButton: ProductOrderButton
  prevButton: ProductOrderButton
}

// подвал заявки (фиксированный внизу экрана)
export function ProductOrderFooter({
  nextButton,
  prevButton,
}: ProductOrderFooterProps) {
  return (
    <div className={style.footer}>
      <Button
        onClick={nextButton.onClick}
        endIcon={nextButton.Icon}
        disabled={nextButton?.disabled || nextButton?.isLoading}
        variant='contained'
        data-testid='order-footer-next'
      >
        {nextButton?.isLoading && (
          <LoaderInCentalPosition className={style.loader} />
        )}
        {nextButton.text}
      </Button>
      <Button
        onClick={prevButton.onClick}
        startIcon={prevButton.Icon}
        variant='text'
        data-testid='order-footer-prev'
      >
        {prevButton.text}
      </Button>
    </div>
  )
}
